'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:pay:payment');
}

var _invoke = require('../invoke');

/**
 * 调用客户端收银台
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof pay
 * @static
 * @name payment
 * @param {Object} opts 收银台参数
 * @returns {Promise<orderId | Undefined>}
 * @example
 *  hbnb.pay.payment({
 *      tradeNo: '123',
 *      payToken: '456',
 *      orderId: '789',
 *      returnURL: 'imeituan://...'
 *  }).then(function(data) {
 *      data = {
 *          isPayed: true,
 *          orderId: '789'
 *      }
 *  }).catch(function() {
 *      ...
 *  });
 */

module.exports = function(opts) {
    if (process.env.NODE_ENV !== 'production') {
        debug('payment opts is %j', opts);
    }
    var p = new Promise(function(resolve, reject) {
        var cb = opts.callback;
        opts.callback = function(data) {
            if (process.env.NODE_ENV !== 'production') {
                debug('payment return %j', data);
            }

            resolve(data);
            if (typeof cb === 'function') {
                cb(data);
            }
        };
        opts.errback = function() {
            reject();
        };
        _invoke('pay', 'cashier', opts);
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/pay/payment.js
// module id = 608
// module chunks = 0